import type * as images from 'assets/svgs'
import { type FC, type SVGProps, useEffect, useRef, useState } from 'react'

export type IconName = keyof typeof images

export const useDynamicSvg = (name: string) => {
  const importedIconRef = useRef<FC<SVGProps<SVGElement>>>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>()

  useEffect(() => {
    setLoading(true)
    const importSvgIcon = async (): Promise<void> => {
      try {
        importedIconRef.current = (await import(`../assets/svgs/${name}.svg`)).default
      } catch (err) {
        setError(err)
        console.error(`Error loading SVG icon: ${name}`, err)
      } finally {
        setLoading(false)
      }
    }

    importSvgIcon()
  }, [name])

  return {
    error,
    loading,
    SvgIcon: importedIconRef.current,
  }
}
